// extracted by mini-css-extract-plugin
export default {"container":"PlanSavingsBadge_container__mczoM","amount":"PlanSavingsBadge_amount__fxz79","text":"PlanSavingsBadge_text__TBhEz"};